<template>
  <div class="main-view-padding has-header">
    <div class="header main" v-header-position-lock>
      <div class="align-left"></div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons" />
      </div>
      <div class="align-right"></div>
    </div>

    <hr />
    <strong>CONTEXT</strong><br />
    Siehe Bild im TEAMS
    <br />
    <hr />
    <strong>ToDo (primary)</strong><br />
    Standardmäßig soll für jede CompanyGroup immer eine "default" Kampagnen
    sofort automatisch für jeden KampagnenType angelegt werden.<br />
    Die Kampagnen soll dann zum Beispiel "Allgemein - MeinPlayer",
    beziehungsweise "Allgemein - App" heißen.<br />
    Überleg dir wie du garantieren kannst, dass es solche Kampagnen immer gibt.
    Zum Beispiel kannst du das beim "Sync" Job prüfen und gegebenenfalls anlegen
    lassen.<br />
    <br />
    Behalte im Hinterkopf, wenn ein Player "unsubscribed" dann hat das
    Auswirkungen darauf, dass die Promo-Files (wenn welche vorhanden sind)
    wieder von dem Player gelöscht werden müssen.<br />
    Also dieser API Aufruf triggert dann im Hintergrund etwas.<br />

    <br />
    <strong>ToDo (minor)</strong><br />
    Wenn es sich zeitlich ergibt, dann kannst du einen Main-Tab machen, wo man
    die Kampagnen verwalten kann.<br />
    Also, dass man als User selber Kampagnen hinzufügen / bearbeiten / etc
    kann.<br />
    Man soll aber die "Default" Kampagnen nicht löschen können.<br />
    Wie besprochen im Teams-Call. Das macht auf Company Ebene erstmal mehr Sinn
    - Wegen Opt-In/Opt-Out.<br />
    <br />
    <hr />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import button from "../uicomponents/button.vue";
export default {
  components: { button },
  name: "todo",
  data() {
    return {
      companies: [],
    };
  },
  created: function () {
    //console.log("CREATED");
  },
  mounted: function () {
    if (
      this.$store.state.jwt != undefined &&
      this.$store.state.companyId != undefined
    ) {
      this.refresh();
    }
  },
  computed: {
    ...mapGetters(["companyId", "isSuperUser"]),

    headerButtons() {
      let view = this;
      let state = { buttons: [] };
      /*
              state.buttons.push({ type: "block", icon: "fa-eye", click: () => { }, tooltip: 'VIEW' });
              state.buttons.push({ type: "block", icon: "fa-cloud-download-alt", click: () => { view.loadExternalUsersFromKundencenter(); }, tooltip: 'SYNC' });
              */
      return state;
    },
  },
  watch: {
    companyId: function (val, oldVal) {
      this.refresh();
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      let view = this;
    },
  },
};
</script>

<!-- Add "scoped" attriemployeete to limit CSS to this component only -->
<style scoped>
.xColumn3 {
  width: 400px;
  text-align: left;
  float: left;
  margin-left: 25px;
  margin-right: 25px;
  overflow-y: auto;
  max-height: 800px;
}
</style>
